/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import ThumbTutorial from 'components/atoms/thumb_tutorial';
import HelpVideoModal from 'components/molecules/help_video_modal';
import { TutorialItem } from 'components/atoms/open_tutorial/tutorials';
import { Container } from './styles';

interface TutorialContainerProps {
  TutorialOpened: boolean;
  setTutorialOpened: React.Dispatch<React.SetStateAction<boolean>>;
  Tutorial: TutorialItem[];
}

const TutorialContainer = (props: TutorialContainerProps) => {
  const { TutorialOpened, setTutorialOpened, Tutorial } = props;

  const [modalVideoOpened, setModalVideoOpened] = useState<boolean>(false);
  const [urlVideo, setUrlVideo] = useState<string>('');

  const handleOpenModal = (url: string): void => {
    setUrlVideo(url);
    setModalVideoOpened(true);
  };

  return (
    <Container className={`${TutorialOpened ? 'd-block' : 'd-none'}`}>
      <div
        className="bg-open"
        aria-hidden="true"
        onClick={() => {
          setTutorialOpened(false);
        }}
      />
      <div className="bg-container py-5 position-absolute">
        <div className="container-fluid big-resolutions">
          <div className="row">
            <div className="col-12 mb-3 d-flex justify-content-between">
              <h4 className="text-light">Veja como funciona</h4>
              <button
                aria-label="Close"
                className="close"
                type="button"
                onClick={() => setTutorialOpened(false)}
              >
                <span className="text-light" aria-hidden="true">
                  ×
                </span>
              </button>
            </div>
          </div>
          <div className="row">
            {Tutorial.map((item) => (
              <div className="col-4 mb-3" key={item.video}>
                <div className="card p-3 h-100">
                  <h5 className="mb-3">{item.title}</h5>
                  <ThumbTutorial video={item.video} img={item.thumb} onClick={handleOpenModal} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <HelpVideoModal
        modalVideoOpened={modalVideoOpened}
        setModalVideoOpened={setModalVideoOpened}
        urlVideo={urlVideo}
      />
    </Container>
  );
};

export default TutorialContainer;
